// import React from 'react';

import { CONFIG_ITEM_KEYS } from '../../config-items/config-item-keys';
import { createEditorPluginAIConfigItemMarkdown, isInitialContextSelectionRange } from '../../config-items/config-items';
import { sliceOrNodeToMarkdown } from '../../config-items/slice-or-node-to-markdown';
import { rovoChatWithAgent } from '../../provider/prompt-requests/rovo-chat';
import { createContinueInChat } from '../config-item-actions/agent';
import { createInsertAtCurrentPosition, createReplace } from '../config-item-actions/markdown';
import { messages } from './messages';

// import { AgentIcon } from '../assets/icons/agent-icon/AgentIcon';

export var createAgentConfigItem = function createAgentConfigItem(selectionType, agent, editorPluginAIProvider) {
  var _editorPluginAIProvid, _editorPluginAIProvid2;
  var continueInChat = createContinueInChat({
    appearance: 'secondary',
    agent: agent,
    product: editorPluginAIProvider.product,
    actionSideEffect: (_editorPluginAIProvid = editorPluginAIProvider.actionSideEffects) === null || _editorPluginAIProvid === void 0 ? void 0 : _editorPluginAIProvid['continueInChat'],
    actionOverride: (_editorPluginAIProvid2 = editorPluginAIProvider.actionOverrides) === null || _editorPluginAIProvid2 === void 0 ? void 0 : _editorPluginAIProvid2['continueInChat']
  });
  return createEditorPluginAIConfigItemMarkdown({
    key: CONFIG_ITEM_KEYS.ROVO_AGENT,
    title: messages.title,
    description: messages.description,
    selectionType: selectionType,
    agent: agent,
    // icon: () => (
    //   <AgentIcon
    //     size="small"
    //     agent={{ name: agent.name, named_id: agent.namedId }}
    //   />
    // ),
    getInitialContext: function getInitialContext(_ref) {
      var editorView = _ref.editorView,
        positions = _ref.positions,
        intl = _ref.intl,
        updateIdMap = _ref.updateIdMap,
        mentionMap = _ref.mentionMap;
      var selection = sliceOrNodeToMarkdown({
        slice: editorView.state.doc.slice(positions[0], positions[1]),
        editorView: editorView,
        convertTo: 'markdown',
        updateIdMap: updateIdMap,
        selectionType: selectionType,
        mentionMap: mentionMap
      });
      var document = sliceOrNodeToMarkdown({
        node: editorView.state.doc,
        editorView: editorView,
        convertTo: 'markdown',
        updateIdMap: updateIdMap,
        selectionType: selectionType,
        mentionMap: mentionMap
      });
      return {
        selection: selection.markdown,
        document: document.markdown,
        userLocale: intl.locale,
        intentSchemaId: 'DISABLED'
      };
    },
    triggerPromptRequest: function triggerPromptRequest(_ref2) {
      var initialContext = _ref2.initialContext,
        editorSchema = _ref2.editorSchema,
        promptInput = _ref2.promptInput,
        promptInputADF = _ref2.promptInputADF;
      return rovoChatWithAgent({
        agent: agent,
        customPrompt: promptInput || '',
        customPromptADF: promptInputADF,
        fullDocument: initialContext.document,
        currentSelection: isInitialContextSelectionRange(initialContext) ? initialContext.selection : ''
      });
    },
    // Required, since hasInitialPreset guard in palette state machine
    // checks this property for whether to transition to 'preset label'
    // (agent palette mode) during initialisation.
    promptLabel: {
      defaultMessage: agent === null || agent === void 0 ? void 0 : agent.name,
      id: "fabric.editor.ai.config.item.".concat(selectionType, ".agent.").concat((agent === null || agent === void 0 ? void 0 : agent.name.toLocaleLowerCase().replace(/\s+/g, '.')) || 'label')
    },
    promptHint: messages.promptHint,
    isVisible: function isVisible() {
      return true;
    },
    getBackendModel: function getBackendModel() {
      return 'assistance-service';
    },
    statusLozengeType: 'beta',
    disableInterrogation: function disableInterrogation() {
      return false;
    },
    actions: selectionType === 'empty' ? [continueInChat, createInsertAtCurrentPosition({
      appearance: 'primary',
      isRovoAgentAction: true
    })] : [continueInChat, createReplace({
      appearance: 'primary',
      isRovoAgentAction: true
    })],
    secondaryActions: []
  });
};